import { AxiosInstance } from "axios";
import Notification from "@/types/app/notifications";

export async function getNotifications(url: string, type: string, api: AxiosInstance): Promise<Notification[]> {
  const response = await api.get(`${url}?typeNotification=${type}`);
  const notifications = response.data as Notification[];
  return notifications;
}

export async function getNotificationById(url: string, notificationId: string, api: AxiosInstance): Promise<Notification> {
  const response = await api.get(`${url}/${notificationId}`);
  const notifications = response.data as Notification;
  return notifications;
}
